import React, { Component } from 'react';
import withRouter from '../../helpers/withWrapper'

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import levelPrices from "../../services/levelPrice";
import getWallet from "../../services/wallet";
import { getGlobalRewardContractSlot1, getGlobalRewardContractSlot2, getGlobalRewardContractSlot3, getOwnerContract } from "../../services/contract";
import getContract from "../../services/contract";

import moment from "moment";
import { ethers } from 'ethers';

class Pools extends Component {
    state = {
        contract: null,
        level: 1,
        shareInfos: [],
        currentPoolId: 0,
        totalShares: 0,
        timeLeftToClaim: '30 d'
    }

    constructor(props) {
        super(props);
        if(props.router.params.id) {
            this.state.userId = props.router.params.id;
        } else {
            this.state.userId = 1;
        }
        if(props.router.params.level) {
            this.state.level = props.router.params.level;
        }
        this.props.onSetUserId(this.state.userId);
    }


    async componentDidMount(props) {
      try {
                
        const promise = this.initializeState();
            await toast.promise(
              promise,
                {
                  pending: 'Fetching Global Rewards',
                  success: 'Global Rewards Fetched! 👌',
                  error: 'Fetching Global Rewards failed'
                }
            )
      } catch (error) {
        console.log(error);
      }
    }

    async initializeState() {
      const wallet = await getWallet();
      let contract;
      if (this.state.level == 1) {
        console.log("level: ", this.state.level);
        contract = await getGlobalRewardContractSlot1();
      } else if (this.state.level == 2) {
        console.log("level: ", this.state.level);
        contract = await getGlobalRewardContractSlot2();
      } else if (this.state.level == 3) {
        console.log("level: ", this.state.level);
        contract = await getGlobalRewardContractSlot3();
      }


      const currentPoolId = ethers.BigNumber.from(await contract.currentPoolNumber()).toNumber();

      // const timeLeftInEpoch = ethers.BigNumber.from(
      //   await contract.getCurrentPoolTimeLeft()
      // ).toNumber();

      const currentPoolStartTimeInEpoch_inSec = ethers.BigNumber.from(await contract.poolStartTime(currentPoolId)).toNumber();

      // const claimPeriodInEpoch_inSec = ethers.BigNumber.from(await contract.claimPeriod()).toNumber();
      const poolEndTimeInEpoch_inSec = ethers.BigNumber.from(await contract.poolEndTime(currentPoolId)).toNumber();
      
      const claimPeriod_inMiliSec = (poolEndTimeInEpoch_inSec) * 1000;      


      const totalSharesBN = await contract.totalShares();
      const totalShares = ethers.BigNumber.from(totalSharesBN).toNumber();
      console.log("Total Shares ", totalShares);

      const amountPerPoolBN = await contract.amountPerPool(currentPoolId);
      const amountPerPool = parseFloat(ethers.utils.formatUnits(amountPerPoolBN)).toFixed(2);

      const sharesPerPoolBN = await contract.totalSharesPerPool(currentPoolId);
      const sharesPerPool = ethers.BigNumber.from(sharesPerPoolBN).toNumber();

      const isEligible = await contract.isEligible(this.state.userId);

      let totalShareIncomeEarned = 0.00;
      if(isEligible) {
        totalShareIncomeEarned = parseFloat(ethers.utils.formatUnits(await contract.getAllShareIncome(this.state.userId))).toFixed(2);
      }
      // const totalIncomeUnClaimed = await contract.getAllUnClaimedShareIncome(this.state.userId)

      let shareInfos = [];
      if(isEligible) {
        for(let i = 1; i <= currentPoolId; i++) {
          const shareInfoResponse = await contract.getShareInfo(this.state.userId, i);

          const poolId = i;
          const shareIncome = parseFloat(ethers.utils.formatUnits(shareInfoResponse[0])).toFixed(2);
          const userShare = ethers.BigNumber.from(shareInfoResponse[1]).toString();

          const totalShareInPool = ethers.BigNumber.from(shareInfoResponse[2]).toString();
          const startTime = this.getDateInMiliSecFromSec(
            ethers.BigNumber.from(shareInfoResponse[3]).toNumber()
          ).toDateString();
          const endTime = this.getDateInMiliSecFromSec(
            ethers.BigNumber.from(shareInfoResponse[4]).toNumber()
          ).toDateString();
          const claimable = shareInfoResponse[5];
          const isClaimed = shareInfoResponse[6];
          const isEligibleForPool = shareInfoResponse[7];
          
          const amountPerPool = parseFloat(ethers.utils.formatUnits(await contract.amountPerPool(poolId))).toFixed(2);

          if(isEligibleForPool) {
            shareInfos.push({poolId, shareIncome, userShare, totalShareInPool, startTime, endTime, claimable, isClaimed, amountPerPool});
          }

        }
      }
      
      const userCurrentPoolShares = ethers.BigNumber.from(
        await contract.getCorrectUserShareInPool(this.state.userId, currentPoolId)
      ).toNumber();
      
      let currentPoolIncome = 0.00;
      if(isEligible) {
        currentPoolIncome = +shareInfos[shareInfos.length-1].shareIncome;
      }

      const sharePercent = (userCurrentPoolShares / totalShares * 100).toFixed(2);

      // const userTotalShares = ethers.BigNumber.from(
      //   await constract.userTotalShares(this.state.userId)
      // ).toString();

      shareInfos = shareInfos.sort((a, b) => b.poolId - a.poolId);

      let timeLeftToClaim = '';
      
      const startDate = Date.now();
      let formatDate = moment.duration(claimPeriod_inMiliSec - startDate)
      
      if (formatDate && (claimPeriod_inMiliSec >= startDate)) {
          if ( formatDate.months() > 0 ) {
              timeLeftToClaim = `${Math.round(formatDate.asDays())}d ${formatDate.hours()}h ${formatDate.minutes()}m`
          }
          else {
              timeLeftToClaim = `${formatDate.days()}d ${formatDate.hours()}h ${formatDate.minutes()}m`
          }
      } else {
        timeLeftToClaim = "0d 0h 0m"
      }

      if (totalShares == 0) {
        timeLeftToClaim = "0d 0h 0m"
      }

      this.setState({totalShares, currentPoolId, amountPerPool, userCurrentPoolShares, currentPoolIncome, 
        timeLeftToClaim, sharePercent, shareInfos, totalShareIncomeEarned, contract})
    }

    async claimReward(poolId) {
      
      try {
        const wallet = await getWallet();
          if(wallet.isReadOnly) {
              alert("Please connect your wallet");
              return;
          }
          
            let contract = (this.state.userId == 1) ? await getContract() : this.state.contract;
            // const claimRewardPromise = contract.claimRewards(this.state.userId, poolId, 
            //   {gasPrice: ethers.utils.parseUnits(wallet.maxFeePerGas.toString(), 'gwei')});
            
            let claimRewardPromise;  
            if(this.state.userId == 1) {
              claimRewardPromise = contract.claimRewards(this.state.level, poolId);
            } else {
              claimRewardPromise = contract.claimRewards(this.state.userId, poolId);
            }
            await toast.promise(
              claimRewardPromise,
                {
                  pending: 'Claiming Rewards in progress',
                  success: 'Rewards Sent to You!',
                  error: 'Claim Rewards failed'
                }
            )

          await this.initializeState();
      } catch (error) {
        alert(error.reason)
      }
    }

    getDateInMiliSecFromSec(x) {
        const myDate = new Date(x * 1000);
        return myDate;
     }

    render() {


        return (
          <div className="flex flex-shrink w-full flex-col items-center min-h-screen bg-main pt-20 sm:pt-14">
            {/* <ToastContainer position="bottom-right" /> */}
            <div className="flex relative flex-1 py-2 pt-8.5 flex-col justify-between w-full px-10 sm:px-0 sm:pt-7.5">
              {/* Top Panel, Matrix levels and all activies inside below div */}
              <div className="flex flex-col w-full space-y-10 sm:space-y-5">
                {/* Top panel of Dashboard mobile view inside below div */}
                <div className="flex w-full items-start justify-between space-x-10 lg:space-x-2.5 sm:space-x-0 sm:space-y-5 sm:flex-col sm:px-5">
                  <div className="flex items-start flex-shrink-0 sm:flex-shrink">
                    <div className="flex-shrink-0 relative w-30 h-30 rounded-full cursor-pointer sm:w-15 sm:h-15">
                      <div className="w-26 h-16 sm:h-14 sm:w-14 false rounded-full p-2">
                        <img src="/logo/logo.png" />
                      </div>
                    </div>
                    <div className="flex flex-col items-start ml-6 h-full justify-center my-auto">
                      <div className="flex justify-center items-center mb-1 sm:mb-2.5">
                        <h3
                          className="font-bold text-3xl mr-2.5 sm:text-xl cursor-pointer showContractId"
                          style={{ color: "#ffc10c" }}
                        >
                          Slot {this.state.level} Global Rewards {" "} - ID {this.state.userId}
                        </h3>
                      </div>
                      <div className="flex flex-col items-start">
                        <div className="flex items-center mb-1">
                          <span className="text-white font-bold mr-2.5 text-base sm:text-sm showWalletAddress">
                            Current running Pool number is {this.state.currentPoolId}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="relative flex flex-grow max-w-500px w-full h-full flex-col p-5 justify-between bg-black-light rounded sm:max-w-full">
                    <div className="flex items-center">
                      <h3
                        className="text-base sm:text-sm"
                        style={{ fontSize: "20px" }}
                      >
                        Global Rewards Eligibility:
                      </h3>
                    </div>
                    <div className="md:flex flex-wrap justify-between false">
                      <span className="text-white-00 text-lg font-bold lg:mb-2.5 sm:text-xl">
                        For Eligibility of global rewards User must have 6 partners or more
                      </span>
                    </div>
                  </div>
                </div>
                {/* Top panel of Dashboard mobile view inside above div */}

                {/* Top panel Partners, Team, Profit ration, Profits View inside below div */}
                <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                  <div className="flex w-full flex-wrap lg:flex-col">
                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                      <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                        <div className="flex items-center">
                          <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                            Total Shares
                          </h4>
                        </div>
                        <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.totalShares}
                        </span>
                      </div>
                      <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                        <div className="flex items-center">
                          <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                            Total Amount in current pool
                          </h4>
                        </div>
                        <span
                          className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5"
                          id="yourTeamTreeCount"
                        >
                          {this.state.amountPerPool} USDT
                        </span>
                      </div>
                      <div className="lg:flex-grow flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                        <div className="flex items-center">
                          <h4 className="text-base sm:text-sm sm:whitespace-nowrap">
                            My Shares
                          </h4>
                        </div>
                        <span
                          className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5"
                          id="yourTeamTreeCount"
                        >
                          {this.state.userCurrentPoolShares}
                        </span>
                      </div>
                      <div className="lg:flex-grow sm:max-w-full flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                        <div className="flex items-center">
                          <h4 className="text-base text-lg sm:text-sm sm:whitespace-nowrap">
                            My Current pool income
                          </h4>
                        </div>
                        <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.currentPoolIncome} USDT
                        </span>
                      </div>
                      <div className="lg:flex-grow sm:max-w-full flex flex-col p-5 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                        <div className="flex items-center">
                          <h4 className="text-base text-lg sm:text-sm sm:whitespace-nowrap">
                            My Share Percent
                          </h4>
                        </div>
                        <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.sharePercent} %
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex w-full mt-15 sm:mt-5 sm:px-5">
                  <div className="flex w-full flex-wrap lg:flex-col">
                    <div className="flex mr-10 space-x-10 lg:mr-0 lg:mt-10 sm:mt-5 sm:space-x-5 lg:order-2 sm:overflow-auto sm:w-full">
                      <div className="lg:flex-grow sm:max-w-full flex flex-col p-6 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                        <div className="flex items-center">
                          <h4 className="text-base text-lg sm:text-sm sm:whitespace-nowrap">
                            Total Earned
                          </h4>
                        </div>
                        <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                          {this.state.totalShareIncomeEarned} USDT
                        </span>
                      </div>
                      <div className="lg:flex-grow sm:max-w-full flex flex-col p-6 bg-black-light rounded desktop-infoblock-base sm:mobile-infoblock-base">
                        <div className="flex items-center">
                          <h4 className="text-base text-lg sm:text-sm sm:whitespace-nowrap">
                          Time Left to Claim Current Pool
                          </h4>
                        </div>
                        <span className="text-2xl font-bold sm:text-xl mt-5 sm:mt-2.5">
                        {this.state.timeLeftToClaim}
                        </span>
                      </div>
                    </div>
                    
                  </div>
                </div>
                {/* Top panel Partners, Team, Profit ration, Profits View inside above div */}
              </div>
              {/* Top Panel, Matrix levels and all activies inside above div */}
              <h1
                style={{
                  fontSize: "25px",
                  marginTop: "40px",
                  marginBottom: "20px",
                }}
              >
                Global Rewards Pools History
              </h1>
              <div className="sm:rounded-none z-10 flex flex-1 flex-col w-full flex-col bg-black-light rounded overflow-hidden h-full min-h-90 sm:max-h-3/4">
                <div className="overflow-auto">
                  <table className="min-w-max w-full table-auto border-white-100">
                    <thead>
                      <tr className="text-white-500 text-xs border-b border-white-100">
                        <th className="p-4 text-left font-normal sm:p-3 ">
                          Pool No
                        </th>
                        <th className="p-4 text-left font-normal sm:p-3">
                          Start Date
                        </th>
                        <th className="p-4 text-left font-normal sm:p-3">
                          End Date
                        </th>
                        <th className="p-4 text-left font-normal sm:p-3">
                          Income
                        </th>
                        <th className="p-4 text-right font-normal sm:p-3">
                          Share in pool
                        </th>
                        <th className="p-4 text-right font-normal sm:p-3">
                          Total pool amount
                        </th>
                        <th className="p-4 text-right font-normal sm:p-3">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-600 text-sm font-light align-baseline">
                      {this.state.shareInfos.map((a, index) => {
                        return (
                          <tr
                            key={index}
                            className="border-b border-blue-100 last:border-none"
                          >
                            <td style={{border: 'none'}} className=" p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white-500 text-sm ">
                                {a.poolId}
                              </div>
                            </td>

                            <td style={{border: 'none'}} className="p-2 text-left whitespace-nowrap sm:p-3">
                              <a
                                className="flex items-left justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max order-2 text-sm"
                                href="#"
                              >
                                {a.startTime}
                              </a>
                            </td>
                            <td style={{border: 'none'}} className="p-2 text-left whitespace-nowrap sm:p-3">
                              <a
                                className="flex items-center justify-center px-2.5 leading-30px bg-blue-100 hover:bg-main-blue-300 text-main-blue rounded font-medium text-base sm:text-sm w-max order-2 text-sm"
                                href="#"
                              >
                                {a.endTime}
                              </a>
                            </td>

                            <td style={{border: 'none'}} className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white text-sm text-left ">
                                {a.shareIncome} USDT
                              </div>
                            </td>
                            <td style={{border: 'none'}} className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white text-sm text-right ">
                                {a.userShare}
                              </div>
                            </td>
                            <td style={{border: 'none'}} className="p-3 text-left whitespace-nowrap sm:p-3">
                              <div className="text-white text-sm text-right ">
                                {a.amountPerPool} USDT
                              </div>
                            </td>
                            {a.claimable && !a.isClaimed ? (
                              <td style={{border: 'none'}} className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-white text-sm text-right ">
                                  <button
                                    onClick={() => this.claimReward(a.poolId)}
                                    className="items-center text-center text-base font-bold text-white rounded-mini sm:text-sm outline-none py-0 px-2.5 bg-blue-600 text-white rounded !leading-30px hover:bg-blue-500 active:bg-active-main-blue w-max flex-shrink-0"
                                  >
                                    Claim
                                  </button>
                                </div>
                              </td>
                            ) : a.isClaimed ? (
                              <td style={{border: 'none'}} className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-white text-sm text-right ">
                                  Claimed
                                </div>
                              </td>
                            ) : (
                              <td style={{border: 'none'}} className="p-4 text-left whitespace-nowrap sm:p-3">
                                <div className="text-white text-sm text-right "></div>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              
            </div>
          </div>
        );
    }
}

export default withRouter(Pools);